import React from 'react';
import { Info, Users, Heart } from 'lucide-react';

export default function AboutUs() {
  return (
    <div className="bg-surface min-h-screen py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 lg:text-center">
          <h2 className="text-accent text-base font-semibold tracking-wide uppercase">About US</h2>
          <p className="font-display text-fg mt-2 text-3xl leading-tight font-semibold tracking-tight sm:text-4xl">
            Connecting You with the Best in Beauty Services
          </p>
          <p className="text-fg-muted mt-4 max-w-2xl text-xl lg:mx-auto">
            We believe everyone deserves to look and feel their best. Our platform makes it easy to
            find and book appointments with top-rated local professionals.
          </p>
        </div>

        <div className="mt-10">
          <dl className="space-y-10 md:grid md:grid-cols-3 md:space-y-0 md:gap-x-8 md:gap-y-10">
            <div className="relative">
              <dt>
                <div className="bg-brand-600 absolute flex h-12 w-12 items-center justify-center rounded-md text-white">
                  <Users className="h-6 w-6" aria-hidden="true" />
                </div>
                <p className="text-fg ml-16 text-lg leading-6 font-medium">Expert Professionals</p>
              </dt>
              <dd className="text-fg-muted mt-2 ml-16 text-base">
                We partner with only the most skilled and highly-rated professionals in your
                community.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <div className="bg-brand-600 absolute flex h-12 w-12 items-center justify-center rounded-md text-white">
                  <Heart className="h-6 w-6" aria-hidden="true" />
                </div>
                <p className="text-fg ml-16 text-lg leading-6 font-medium">Personalized Care</p>
              </dt>
              <dd className="text-fg-muted mt-2 ml-16 text-base">
                Find services tailored to your unique needs, from quick trims to full-day styling
                sessions.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <div className="bg-brand-600 absolute flex h-12 w-12 items-center justify-center rounded-md text-white">
                  <Info className="h-6 w-6" aria-hidden="true" />
                </div>
                <p className="text-fg ml-16 text-lg leading-6 font-medium">Seamless Booking</p>
              </dt>
              <dd className="text-fg-muted mt-2 ml-16 text-base">
                Our intuitive interface allows you to book appointments in seconds, anytime,
                anywhere.
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
